import React, { useEffect, useMemo, useState } from "react";
import { TableProps } from "antd"; // Import Ant Design components
import "./ReviewList.css"; // Import the CSS file
import SetStatus from "../../../../Components/SetStatus/SetStatus";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedInvoice } from "../../../../Reducer/SelectedInvoiceReducer";
import Loader from "../../../../Components/Loader/Loader";
import { Tooltip } from "antd";
import calculatePagination from "../../../../Components/CustomPagination/Pagination/Pagination";
import CommonTable from "../../../../Components/CustomTable/CustomTable";
import Pagination from "../../../../Components/CustomPagination/Pagination/Pagination";
import { useInvoiceActions } from "../../../../hooks/useInvoiceActions";
import { UpdateInvoiceFlagService } from "../../../../Services/InvoiceService/InvoiceService";

interface RowData {
  id: number;
  stageId: number;
  isFlagged: boolean;
  user: string;
  date: string;
  supplier: string;
  category: string;
  advanced: string;
  documentOwner: string;
  discountAmount: number;
  total: number;
  selected: boolean;
  description: any;
  documentReference: string;
  taxAmount: number;
}
interface ReviewListProps {
  setInvoiceView: React.Dispatch<React.SetStateAction<boolean>>;
  invoicesDataSource: any;
  loadMoreInvoicesOnScroll: any;
  isLoadingMore: boolean;
  totalInvoiceCount: number;
  sortInvoices: any;
  onSelectionChange: (ids: number[]) => void;
}

const ReviewList: React.FC<ReviewListProps> = ({
  setInvoiceView,
  invoicesDataSource,
  totalInvoiceCount,
  loadMoreInvoicesOnScroll,
  isLoadingMore,
  sortInvoices,
  onSelectionChange,
}) => {
  const { makeInvoiceViewed } = useInvoiceActions();
  const dispatch = useDispatch();
  const [data, setData] = useState<RowData[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [invoices, setInvoices] = useState<any[]>([]);
  const indexOfLastRecord = currentPage * pageSize;
  const indexOfFirstRecord = indexOfLastRecord - pageSize;

  // ADDITIONL REMOVE LATER
  const initialData: RowData[] = [];
  const [dataSource, setDataSource] = useState<RowData[]>([]); // Static data source
  const recordsPerPage = 10;
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  // Memoize data for the current page
  const currentRecords = useMemo(() => {
    return invoicesDataSource.slice(indexOfFirstRecord, indexOfLastRecord);
  }, [invoicesDataSource, indexOfFirstRecord, indexOfLastRecord]);

  const handleSelectAllChange = (e: any) => {
    const newSelectAll = e.target.checked;
    setSelectAll(newSelectAll);
    setData((prevData) =>
      prevData.map((row) => ({
        ...row,
        selected: newSelectAll,
      })),
    );
  };

  // Reset selection whenever the data source is refreshed
  useEffect(() => {
    setSelectedRows([]);
    onSelectionChange([]);
  }, [invoicesDataSource]);

  useEffect(() => {
    setDataSource(invoicesDataSource);
  }, [invoicesDataSource]);

  const handleCheckboxChange = (id: number) => {
    setData((prevData) =>
      prevData.map((row) =>
        row.id === id ? { ...row, selected: !row.selected } : row,
      ),
    );
  };

  // Handle page change for pagination
  const handlePageChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const selectedClient = useSelector((state: any) => state.selectedClient);

  // Handle invoice row click to view details
  const handleInvoiceClick = (row: RowData) => {
   sessionStorage.setItem("selectedInvoiceId", row.id.toString());

    //localStorage.setItem("part1_currentPage", currentPage.toString());
    dispatch(setSelectedInvoice(row));
    setInvoiceView(true);
    makeInvoiceViewed(row.id, row.stageId);
  };

  const handleSelectAll = () => {
    alert("Select All clicked");
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(invoices.map((inv) => inv.id)); //  IDs only
    }
    setSelectAll(!selectAll);
  };

  const columns = [
    {
      key: "selected",
      title: "selected",
      dataIndex: "",
      isCheckbox: true,
      showSortArrows: false,
      render: (
        <input
          type="checkbox"
          checked={selectAll}
          onClick={(e) => e.stopPropagation()}
          onChange={handleSelectAll}
        />
      ),
    },
    {
      key: "isFlagged",
      title: "",
      dataIndex: "isFlagged",
      showSortArrows: false,
      isFlag: true,
    },

    {
      title: "ID",
      dataIndex: "id",
      key: "invoiceid",
      showSortArrows: true,
      render: (text: string) => (
        <Tooltip title={text}>
          <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "stageId",
      key: "Status",
      isStatus: true,
      showSortArrows: true,
    },
    {
      title: "Submitted By",
      dataIndex: "submittedBy",
      key: "submittedBy",
      showSortArrows: true,
      render: (text: string | null, record: any) =>
        record.submissionMethod?.toLowerCase() === "email"
          ? ""
          : text || "",
    },
    {
      title: "Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      isDate: true,
      showSortArrows: true,
      render: (text: string) => {
        const date = new Date(text); // Parse the ISO date
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }); // Formats as dd/mm/yyyy
        return (
          <Tooltip title={formattedDate}>
            <span>{formattedDate}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
      showSortArrows: true,
      render: (text: string) => (
        <Tooltip title={text}>
          <span>
            {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // isStatus: true,
      showSortArrows: false,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      // isStatus: true,
      showSortArrows: true,
    },

    // {
    //   title: "Invoice Number",
    //   dataIndex: "documentReference",
    //   key: "documentReference",
    //   showSortArrows: false,
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>
    //         {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
    //       </span>
    //     </Tooltip>
    //   ),
    // },
    {
      title: "Total",
      dataIndex: "totalAmount",
      key: "totalAmount",
      showSortArrows: true,
      render: (discountValue: number) => (
        <Tooltip title={discountValue}>
          <span>{discountValue != null ? discountValue.toFixed(2) : "-"}</span>
        </Tooltip>
      ),
    },
    {
      title: "Tax",
      dataIndex: "taxAmount",
      key: "TAXAMOUNT",
      showSortArrows: true,
      // showSortArrows: true,
      // render: (taxAmount: number) => ()
    },
    {
      title: "Document Ref",
      dataIndex: "documentReference",
      key: "DOCUMENTREFERENCE ",
      showSortArrows: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      showSortArrows: true,
      render: (text: string) => (
        <Tooltip title={text}>
          <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
        </Tooltip>
      ),
    },
     {
          title: "Due Date",
          dataIndex: "dueDate",
          key: "dueDate",
          // isStatus: true,
          showSortArrows: true,
          isDate: true,
          render: (text: string) => {
            const date = new Date(text); // Parse the ISO date
            const formattedDate = date.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }); // Formats as dd/mm/yyyy
            return (
              <Tooltip title={formattedDate}>
                <span>{formattedDate}</span>
              </Tooltip>
            );
          },
        },
         {
          title: "Paid",
          dataIndex: "paid",
          key: "Paid",
          // isStatus: true,
          showSortArrows: true,
        },
        {
          title: "Payment",
          dataIndex: "payment",
          key: "payment",
          // isStatus: true,
          showSortArrows: true,
        },
        {
          title: "Submission Method",
          dataIndex: "Submission Method",
          key: "Submission Method",
          // isStatus: true,
          showSortArrows: true,
        },
    {
      title: "Upload Date",
      dataIndex: "createdDate",
      key: "createdDate",
      isDate: true,
      // isStatus: true,
      showSortArrows: true,
    },

    // {
    //   title: "User",
    //   dataIndex: "documentOwner",
    //   key: "documentOwner",
    //   sorter: (a: RowData, b: RowData) => {
    //     const valueA = a.documentOwner || ""; // Empty strings are sorted last
    //     const valueB = b.documentOwner || "";
    //     return valueA.localeCompare(valueB);
    //   },
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    //   sorter: (a: RowData, b: RowData) =>
    //     a.description.toLowerCase().localeCompare(b.description.toLowerCase()),
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Date",
    //   dataIndex: "date",
    //   key: "date",
    //   isDate: true,
    // },
    // {
    //   title: "Supplier",
    //   dataIndex: "supplier",
    //   key: "supplier",
    //   sorter: (a: RowData, b: RowData) =>
    //     a.supplier.toLowerCase().localeCompare(b.supplier.toLowerCase()),
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>
    //         {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
    //       </span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   key: "category",
    //   sorter: (a: RowData, b: RowData) => a.category.localeCompare(b.category),
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Advanced",
    //   dataIndex: "advanced",
    //   key: "advanced",
    //   render: (text: string) => (
    //     <Tooltip title={text}>
    //       <span>{text.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Total",
    //   dataIndex: "total",
    //   key: "total",
    //   sorter: (a: RowData, b: RowData) => a.total - b.total,
    //   render: (discountValue: number) => (
    //     <Tooltip title={discountValue}>
    //       <span>
    //         {discountValue != null ? discountValue.toFixed(2) : "0.00"}
    //       </span>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: "Discount",
    //   dataIndex: "discountAmount",
    //   key: "discountAmount",
    //   sorter: (a: RowData, b: RowData) => a.discountAmount - b.discountAmount,
    //   render: (discountValue: number) => (
    //     <Tooltip title={discountValue}>
    //       <span>
    //         {discountValue != null ? discountValue.toFixed(2) : "0.00"}
    //       </span>
    //     </Tooltip>
    //   ),
    // },
  ];

  // Columns that should always be visible
  const alwaysVisibleColumns = ["selected", "isFlagged", "ID", "Status"];
  const selectedColumns: string[] = JSON.parse(
    localStorage.getItem("selectedColumns") || "[]",
  );
  // Get user-selected columns from localStorage
  // if (selectedColumns.length === 0) {
  //   alwaysVisibleColumns.push("Date","Supplier","Total","Tax","Document Ref","Description",);
  // }

  // Filter columns: always include "selected", "ID", "Status" + any selected by user
  const filteredColumns = columns.filter(
    (col) =>
      alwaysVisibleColumns.includes(col.key as string) ||
      selectedColumns.includes(col.title as string),
  );

   const [flagOverrides, setFlagOverrides] = useState<Record<string | number, boolean>>({});
  
    const handleFlagClick = async (row: RowData) => {
      const currentFlagState = flagOverrides[row.id] ?? row.isFlagged;
      const newFlagState = !currentFlagState;
  
      // Optimistic local update
      setFlagOverrides((prev) => ({ ...prev, [row.id]: newFlagState }));
  
      const result = await UpdateInvoiceFlagService(Number(row.id), newFlagState);
  
      if (!result.success) {
        // Revert on failure
        setFlagOverrides((prev) => ({ ...prev, [row.id]: currentFlagState }));
      }
    };

 useEffect(() => {
  const selectedId = sessionStorage.getItem("selectedInvoiceId");
  if (!selectedId) return;

  // Find the scrollable table wrapper div
  const tableWrapper = document.querySelector(".table-wrapper") as HTMLElement;
  if (!tableWrapper) return;

  let attempts = 0;

  

  const findAndScrollToRow = () => {
    const rowElement = tableWrapper.querySelector(
      `[data-row-id="${selectedId}"]`
    ) as HTMLElement;

    if (rowElement) {
      // Calculate position relative to the scrollable container
      const rowTop = rowElement.offsetTop;
      const rowHeight = rowElement.offsetHeight;
      const containerHeight = tableWrapper.clientHeight;

      // Scroll so the row lands in the center of the container
      tableWrapper.scrollTop = rowTop - containerHeight / 2 + rowHeight / 2;

      sessionStorage.removeItem("selectedInvoiceId");
      return;
    }

    if (attempts < 10) {
      attempts++;
      loadMoreInvoicesOnScroll(); // load more data silently
      setTimeout(findAndScrollToRow, 300);
    } else {
      sessionStorage.removeItem("selectedInvoiceId");
    }
  };

  setTimeout(findAndScrollToRow, 200);
}, [invoicesDataSource]);
  


  //!!! Missing onChangeTableParams

  // Loader if no data
  if (invoicesDataSource.length === 0) {
    return <Loader />;
  }

  const onRowCheckboxChange = (row: Record<string, any>, checked: boolean) => {
    // onSelectionChange(selectedRows);
    setSelectedRows((prevKeys) => {
      const updatedKeys = checked
        ? prevKeys.includes(row.id)
          ? prevKeys
          : [...prevKeys, row.id]
        : prevKeys.filter((id) => id !== row.id);

      // Call with updatedKeys here, inside the setter — not with stale selectedRows
      onSelectionChange(updatedKeys);
      return updatedKeys;
    });
  };

  if (dataSource.length === 0) {
    return (
      <div>
        <h1>No invoices found for this client</h1>
      </div>
    );
  }
 
  return (
    <div className="InboxInvoiceList">
      <div className="custom-table-wrapper">
        <CommonTable
          sortInvoices={sortInvoices}
          onFlagClick={handleFlagClick}
          infinityScroll={true}
          loadMoreInvoicesOnScroll={loadMoreInvoicesOnScroll}
          columns={filteredColumns}
          data={invoicesDataSource.map((row: RowData) => ({
            ...row,
            isFlagged: flagOverrides[row.id] ?? row.isFlagged,
          }))}
          selectedRowKeys={selectedRows} //{selectedRowKeys}
          onRowCheckboxChange={onRowCheckboxChange}
          handleSelectAll={(checked: boolean) => {
            const allIds = checked
              ? invoicesDataSource.map((inv: any) => inv.id)
              : [];
            setSelectedRows(allIds);
            onSelectionChange(allIds);
          }}
          onRow={(record: RowData) => ({
            onClick: (e) => {
              //  If click comes from checkbox, do nothing
              if ((e.target as HTMLElement).closest("input[type='checkbox']")) {
                return;
              }

              //  Otherwise open invoice
              handleInvoiceClick(record);
            },
          })}
          stageId={1} // pass current stageId
          userId={selectedClient.selectedClient?.userId}
          totalCount={totalInvoiceCount}
        />
      </div>

      <h2 style={{ textAlign: "center", color: "var(--color-brand)" }}>
        {isLoadingMore ? " Loading... " : dataSource.length} /{" "}
        {totalInvoiceCount}{" "}
      </h2>
    </div>
  );
};

export default ReviewList;
